import React, { createContext, useState, useMemo } from 'react';

const DebugContext = createContext();

const DebugProvider = ({ children }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const debug = urlParams.get('debug');
  const [isDebug, setIsDebug] = useState(debug === '1');

  const contextValue = useMemo(() => ({ isDebug, setIsDebug }), [isDebug]);

  return (
    <DebugContext.Provider value={contextValue}>
      {children}
    </DebugContext.Provider>
  );
};

export { DebugContext, DebugProvider };